import type { BaseModalProps } from '@byecode/ui'
import { DesktopModal, Modal } from '@byecode/ui'
import React from 'react'

import WeChatPayAccount from './WeChatPayAccount'

interface WeChatPayAccountModalProps extends BaseModalProps {}

export const WeChatPayAccountModal: React.FunctionComponent<WeChatPayAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                modal: {
                    maxHeight: 'calc(100% - 48px)'
                },
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <WeChatPayAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
